import React from 'react'

// api
import { InboxType } from '../../../../../server/models/Inbox'
import { useInboxPublicationsQuery } from '../../../../requests/inboxes'

import './styles.css'

type Props = {
  inbox: InboxType
}

export const ListInboxPublications: React.FC<Props> = ({ inbox }) => {
  const { data: publications = [], isLoading: loading } = useInboxPublicationsQuery(
    inbox._id || '',
    {
      enabled: !!inbox._id, // Only fetch if inbox ID exists
    }
  )

  return (
    <button className="list-inbox-publications-btn" title="Click to keep open">
      { inbox.name }
      <ul className="list-inbox-publications-items">
        {loading && <li>Loading publication names...</li>}

        {!loading && (
          <>
            {publications.map((publication) => (
              <li key={publication}>{publication}</li>
            ))}
          </>
        )}

        {!loading && !publications.length && (
          <li>No publications found.</li>
        )}
      </ul>
    </button>
  )
}
